// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"388":"result","976":"share","982":"process"}[chunkId] || chunkId) + "." + {"223":"7b31acb9","388":"95bd953d","976":"fb0657f7","982":"f89b0d63"}[chunkId] + ".js";
};